// Shared lookups for Property admin forms.
// Kept in one place so PropertyFormModal + PropertiesManagement (table + filter)
// stay in sync.

export const propertyTypes = [
  { value: 'villa', label: 'Villa' },
  { value: 'apartment', label: 'Apartment' },
  { value: 'house', label: 'House' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'land', label: 'Land' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: 'boutique_hotel', label: 'Boutique Hotel' },
];

export const statusOptions = [
  { value: 'for_sale', label: 'For Sale' },
  { value: 'for_rent_short', label: 'For Rent (Short-term / Nightly) — Managed by Lalita' },
  { value: 'for_rent_long', label: 'For Rent (Long-term / Monthly-Yearly)' },
];

// For type=land, only For Sale or Long-term lease make sense (no nightly stays for empty land)
export const landStatusOptions = [
  { value: 'for_sale', label: 'For Sale' },
  { value: 'for_rent_long', label: 'For Rent (Long-term / Yearly Lease)' },
];

export const ownershipTypes = [
  { value: '', label: 'None' },
  { value: 'freehold', label: 'Freehold' },
  { value: 'leasehold', label: 'Leasehold' },
  { value: 'both', label: 'Both (Freehold & Leasehold)' },
];

export const amenitiesOptions = [
  'private_pool', 'garden', 'ocean_view', 'staff_included',
  'beach_access', 'parking', 'wifi', 'air_conditioning', 'spa', 'gym',
];

// Land-specific amenity / feature checklist (replaces villa amenities when type=land)
export const landAmenitiesOptions = [
  'ocean_view', 'rice_field_view', 'mountain_view', 'beach_access',
  'road_frontage', 'corner_plot', 'utilities_available', 'river_stream',
  'cleared_ready_to_build',
];

export const zoningOptions = [
  { value: '', label: '—' },
  { value: 'residential', label: 'Residential (Yellow)' },
  { value: 'tourism', label: 'Tourism (Pink)' },
  { value: 'mixed', label: 'Mixed Use (Orange)' },
  { value: 'agricultural', label: 'Agricultural (Green)' },
  { value: 'unknown', label: 'Unknown' },
];

// Tailwind classes used to render the zoning swatch / badge color.
// Map matches the colour code Bali planners use on RTRW zoning maps.
export const zoningSwatchClass = {
  residential: 'bg-yellow-400',
  tourism: 'bg-pink-400',
  mixed: 'bg-orange-400',
  agricultural: 'bg-green-500',
  green_zone: 'bg-green-500', // legacy alias
  unknown: 'bg-gray-300',
};

export const certificateOptions = [
  { value: '', label: '—' },
  { value: 'SHM', label: 'SHM (Sertifikat Hak Milik / Freehold)' },
  { value: 'SHGB', label: 'SHGB (Sertifikat Hak Guna Bangunan)' },
  { value: 'other', label: 'Other' },
];

export const roadAccessOptions = [
  { value: '', label: '—' },
  { value: 'paved_road', label: 'Paved Road' },
  { value: 'concrete_path', label: 'Concrete Path' },
  { value: 'dirt_path', label: 'Dirt Path' },
  { value: 'no_direct', label: 'No Direct Access' },
];

export const emptyForm = {
  name: '',
  display_name: '',
  listing_code: '',
  slug: '',
  location: '',
  address: '',
  description: '',
  short_description: '',
  bedrooms: 1,
  bathrooms: 1,
  land_size: '',
  building_size: '',
  price: '',
  price_currency: 'IDR',
  rental_price: '',
  rental_price_currency: 'IDR',
  monthly_rental_price: '',
  monthly_rental_price_currency: 'IDR',
  yearly_rental_price: '',
  yearly_rental_price_currency: 'IDR',
  // Short-term rental fields
  max_guests: '',
  min_nights: '1',
  max_nights: '',
  cleaning_fee: '',
  check_in_time: '15:00',
  check_out_time: '11:00',
  // Leasehold fields
  lease_years_remaining: '',
  lease_expiry_year: '',
  lease_extendable: false,
  status: 'for_sale',
  property_type: 'villa',
  ownership_type: '',
  amenities: [],
  // Land-specific fields
  zoning: '',
  road_access: '',
  certificate_of_ownership: '',
  images: [],
  cover_image: '',
  latitude: '',
  longitude: '',
  meta_title: '',
  meta_description: '',
  featured: false,
};

export const generateSlug = (name) =>
  name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
